import { render, staticRenderFns } from "./FormAssociantePersonalInfo.vue?vue&type=template&id=cb87f2d8"
import script from "./FormAssociantePersonalInfo.vue?vue&type=script&lang=js"
export * from "./FormAssociantePersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./FormAssociantePersonalInfo.vue?vue&type=style&index=0&id=cb87f2d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports